/**
 * LangHome.tsx
 * Pages d'accueil dédiées par langue : /en, /de, /nl
 * Chaque page définit la langue, affiche la page d'accueil traduite,
 * et est indexable par les moteurs de recherche avec hreflang.
 */
import { useEffect } from "react";
import { useLocation } from "wouter";
import { useLanguage, type Language } from "@/contexts/LanguageContext";
import NewHome from "./NewHome";

function LangHome({ lang }: { lang: Language }) {
  const { setLang } = useLanguage();
  const [, navigate] = useLocation();

  useEffect(() => {
    setLang(lang);
  }, [lang, setLang]);

  // Injecter les balises hreflang dans le <head>
  useEffect(() => {
    const existing = document.querySelectorAll("link[hreflang]");
    existing.forEach(el => el.remove());

    const hreflangs: { lang: string; path: string }[] = [
      { lang: "fr", path: "/" },
      { lang: "en", path: "/en" },
      { lang: "de", path: "/de" },
      { lang: "nl", path: "/nl" },
      { lang: "x-default", path: "/" },
    ];

    hreflangs.forEach(({ lang: hl, path }) => {
      const link = document.createElement("link");
      link.rel = "alternate";
      link.hreflang = hl;
      link.href = `${window.location.origin}${path}`;
      document.head.appendChild(link);
    });

    return () => {
      document.querySelectorAll("link[hreflang]").forEach(el => el.remove());
    };
  }, []);

  return <NewHome />;
}

export function HomeEN() { return <LangHome lang="en" />; }
export function HomeDE() { return <LangHome lang="de" />; }
export function HomeNL() { return <LangHome lang="nl" />; }
